<template>
    <span ref="component"></span>
</template>

<script>
    import vueCookies from 'vue-cookies';

    const getRandomString = (length = 32) => {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };

    export default {
        props: {
            length: {default: 64},
            trial: {default: '0'}
        },
        data() {
            return {}
        },
        computed: {},
        mounted() {
            const variable = `suid-${this.trial}`;
            let randomString = vueCookies.get(variable);

            if (!randomString) {
                randomString = getRandomString(parseInt(this.length));
                vueCookies.set(variable, randomString, 60 * 60 * 24 * 365);
                console.log({new_uid: {randomString}});
            } else {
                console.log({uid_found: {number: randomString}});
            }

            const questionContainer = $(this.$refs.component).closest('.question-container');
            questionContainer.find('.form-control').val(randomString);
        },
        methods: {},
        watch: {},
        components: {}
    }
</script>
